import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

const baseClassName = ['bg-stone-300', 'rounded-sm', 'animate-pulse'].join(' ');

const skeletonVariants = cva(baseClassName, {
  variants: {
    variant: {
      text: [
        'rounded-[3.125rem]',
        'overflow-hidden',
        'pointer-events-none',
        'h-2',
      ],
      circle: ['rounded-full'],
      rectangular: ['rounded-sm', 'w-full', 'h-[32px]'],
      /** Static variant for grid cells - no animation to avoid style recalc during scroll */
      rectangularStatic: ['rounded-sm', 'w-full', 'h-[32px]', 'animate-none!'],
    },
  },
  defaultVariants: {},
});

export type SkeletonVariantProps = VariantProps<typeof skeletonVariants>;
export type SkeletonSlots = keyof ReturnType<typeof skeletonVariants>;

export { skeletonVariants };
